export default __webpack_public_path__ + "static/media/closet5-after2-1024w.13bd52de.png";